import { render } from "./complaint-page.vue?vue&type=template&id=a8e0af44"
import script from "./complaint-page.vue?vue&type=script&lang=js"
export * from "./complaint-page.vue?vue&type=script&lang=js"

import "./complaint-page.vue?vue&type=style&index=0&id=a8e0af44&lang=scss"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__